import { OverlayModule } from '@angular/cdk/overlay'
import { registerLocaleData } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GestureConfig, MAT_DATE_LOCALE } from '@angular/material'
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter'
import {
	BrowserModule,
	HAMMER_GESTURE_CONFIG
} from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { EffectsModule } from '@ngrx/effects'
import { StoreRouterConnectingModule } from '@ngrx/router-store'
import { StoreModule } from '@ngrx/store'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { TranslateModule } from '@ngx-translate/core'
import 'hammerjs'
import * as json from 'highlight.js/lib/languages/json'
import * as scss from 'highlight.js/lib/languages/scss'
import * as typescript from 'highlight.js/lib/languages/typescript'
import * as xml from 'highlight.js/lib/languages/xml'
import 'moment/locale/fr'
import { InlineSVGModule } from 'ng-inline-svg'
import { HighlightLanguage, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs'
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker'
import {
	PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG
} from 'ngx-perfect-scrollbar'
import { NgxPermissionsModule } from 'ngx-permissions'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { AuthService } from './core/auth'
import { CoreModule } from './core/core.module'
import { metaReducers, reducers } from './core/reducers'
import {
	AtylDialogService, LayoutConfigService,
	LayoutRefService,
	MenuAsideService,
	MenuConfigService,
	MenuHorizontalService,
	PageConfigService,
	SplashScreenService,
	SubheaderService
} from './core/_base/layout'
import { LayoutConfig } from './core/_config/layout.config'
import { FormAtylInputModule } from './motor-form-atyl/form-atyl-components/form-atyl-input/form-atyl-input.module'
import { FormDialogAtylModule } from './motor-form-atyl/form-atyl-components/form-dialog/form-dialog-atyl.module'
import { NomadeModule } from './nomade/nomade.module'
import * as services from './services'
import { ErrorsHandler } from './services/ErrorHandler'
import { AuthModule } from './views/pages/auth/auth.module'
import { DesignModule } from './views/partials/design/design.module'
import { PartialsModule } from './views/partials/partials.module'

// import { GoogleChartsModule } from 'angular-google-charts';
import { AtylHttpClient,AtylHttpClientCreator } from './services/service-http'
import {  HttpHandler,HttpClient } from '@angular/common/http';
import { MatExpansionModule } from '@angular/material'

registerLocaleData(localeFr, 'fr')


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	wheelSpeed: 0.5,
	swipeEasing: true,
	minScrollbarLength: 40,
	maxScrollbarLength: 300
}

export function initializeLayoutConfig(appConfig: LayoutConfigService) {
	return () => {
		if (appConfig.getConfig() === null) {
			appConfig.loadConfigs(new LayoutConfig().configs)
		}
	}
}

export function hljsLanguages(): HighlightLanguage[] {
	return [
		{ name: 'typescript', func: typescript },
		{ name: 'scss', func: scss },
		{ name: 'xml', func: xml },
		{ name: 'json', func: json }
	]
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserAnimationsModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		NgxPermissionsModule.forRoot(),
		PartialsModule,
		CoreModule,
		OverlayModule,
		StoreModule.forRoot(reducers, { metaReducers }),
		EffectsModule.forRoot([]),
		StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
		StoreDevtoolsModule.instrument(),
		AuthModule.forRoot(),
		NgbModule,
		TranslateModule.forRoot(),
		InlineSVGModule.forRoot(),
		ReactiveFormsModule,
		FormsModule,
		NgxMaterialTimepickerModule.setOpts('fr-FR','french'),
		DesignModule,
		FormDialogAtylModule,
		FormAtylInputModule,
		NomadeModule,
		MatExpansionModule,
		/*GoogleChartsModule.forRoot(),*/
	],
	exports: [],
	providers: [
		AuthService,
		LayoutConfigService,
		LayoutRefService,
		MenuConfigService,
		PageConfigService,
		AtylDialogService,
		SplashScreenService,
		services.AdresseService,
		services.AppService,
		services.ConnectionService,
		services.ConsultationService,
		services.CourrierService,
		services.DemandeService,
		services.DocumentService,
		services.DossierService,
		services.DroitsService,
		services.FichierService,
		services.FormulaireService,
		services.ImpressionService,
		services.InstructionService,
		services.ListeService,
		services.NotificationService,
		services.PageService,
		services.PanierService,
		services.ParameterService,
		services.ParametreService,
		services.RendezvousService,
        services.CommunicationService,
		services.SelectionService,
		services.StateService,
		services.SuiviService,
		services.TiersService,
		services.UtilitaryService,
		services.WorkflowService,
		services.DialogService,
		services.VidalService,
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		},
		{
			provide: ErrorHandler,
			useClass: ErrorsHandler
		},
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: GestureConfig
		},
		{
			provide: APP_INITIALIZER,
			useFactory: initializeLayoutConfig,
			deps: [LayoutConfigService],
			multi: true
		},
		{
			provide: HIGHLIGHT_OPTIONS,
			useValue: { languages: hljsLanguages }
		},
		SubheaderService,
		MenuHorizontalService,
		MenuAsideService,
		{ provide: LOCALE_ID, useValue: 'fr-FR' },
		{ provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
		{
			provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
			useValue: { useUtc: true }
		},
		{
			provide: Window, useValue: window
		},{
	      provide: AtylHttpClient,
	      useFactory: AtylHttpClientCreator,
	      deps: [HttpHandler]
	    },
	     {
	      provide: HttpClient,
	      useClass: AtylHttpClient
	    }
	],
	bootstrap: [AppComponent],
	entryComponents: []
})
export class AppModule { }
